import type { FC } from 'react';

import { useTopAreaBanner } from '../../context';
import { TopAreaBannerContent, TopAreaBannerSkeleton } from './components';

export const TopAreaBanner: FC = () => {
  const { loading, visible } = useTopAreaBanner();

  if (!visible) {
    return null;
  }

  return loading ? <TopAreaBannerSkeleton /> : <TopAreaBannerContent />;
};
